import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";

@Component({
    selector: "section-warehouse-order-hold-list",
    template: `
        <section-warehouse-order-list [state]="state" [status]="'on_hold'"
                                      header="Orders on-hold"></section-warehouse-order-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderOnHoldListComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-on-hold",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
